import { render, staticRenderFns } from "./ScrollPane.vue?vue&type=template&id=7f21012e&scoped=true&"
import script from "./ScrollPane.vue?vue&type=script&lang=js&"
export * from "./ScrollPane.vue?vue&type=script&lang=js&"
import style0 from "./ScrollPane.vue?vue&type=style&index=0&id=7f21012e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f21012e",
  null
  
)

export default component.exports